export const STARTER_TEMPLATES = [
    {
        id: 'sensor-offline',
        label: 'Offline Sensor Alert',
        description: 'Get notified when sensors go offline for more than 1 hour.',
        icon: 'wifi_off',
        template: {
            displayName: 'Offline Sensor Alert',
            enabled: true,
            trigger: {
                field: 'connectionStatus',
                connection: 'SENSOR_OFFLINE',
            },
            triggerDelay: '3600s',
            scope: {
                type: 'ALL_PROJECTS',
                labels: {}
            },
            deviceMode: 'ALL',
            deviceLabels: {},
            escalationLevels: [
                {
                    displayName: 'Level 1',
                    escalateAfter: '7200s',
                    actions: [
                        {
                            type: 'EMAIL',
                            email: {
                                recipients: [],
                                contactGroups: [],
                                subject: 'DT Sensor Offline - $name',
                                body: '$name sensor offline for $timeSinceTrigger\n\nhttps://studio.disruptive-technologies.com/projects/$projectID/organization-alerts'
                            }
                        }
                    ]
                }
            ],
            actions: []
        }
    },
    {
        id: 'cloud-connector-offline',
        label: 'Offline Cloud Connector Alert',
        description: 'Get notified when a Cloud Connector goes offline.',
        icon: 'cloud_off',
        template: {
            displayName: 'Offline Cloud Connector Alert',
            enabled: true,
            trigger: {
                field: 'connectionStatus',
                connection: 'CLOUD_CONNECTOR_OFFLINE',
            },
            triggerDelay: '3600s',
            scope: {
                type: 'ALL_PROJECTS',
                labels: {}
            },
            deviceMode: 'ALL',
            deviceLabels: {},
            escalationLevels: [
                {
                    displayName: 'Level 1',
                    escalateAfter: '7200s',
                    actions: [
                        {
                            type: 'EMAIL',
                            email: {
                                recipients: [],
                                contactGroups: [],
                                subject: 'DT CCON Offline - $name',
                                body: '$name Cloud Connector offline for $timeSinceTrigger\n\nConfirm CCON is plugged in. If it is, contact support@disruptive-technologies.com noting the LED color on the device.\n\nhttps://studio.disruptive-technologies.com/projects/$projectID/organization-alerts'
                            }
                        }
                    ]
                }
            ],
            actions: []
        }
    }
];
